import { render, staticRenderFns } from "./GalleryProfile.vue?vue&type=template&id=705b80d2"
import script from "./GalleryProfile.vue?vue&type=script&lang=js"
export * from "./GalleryProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports